<template>
    <section :style="{ backgroundColor: backgroundcolor }">
        <section class="bulettin-data">
            <img src="@/assets/imgs/esesja-blue.png" class="bulettin-data__thumbnail" />
            <section>
                <h5 class="bulettin-data__title" @click="goToNews(data)" style="cursor:pointer"
                    v-tooltip="$t('com.file.bulletin-item.click-open-bulletin')">
                    {{ data.title }}
                </h5>
                <section class="bulettin-data__wrapper">
                    <img class="bulettin-data__icon" src="@/assets/icons/panel/home/callendar-gray.svg" />
                    <span class="bulettin-data__date">{{ data.number }}</span>
                </section>
                <section v-if="withTeaser" class="bulettin-data__bulletin-teaser">{{data.teaser}}</section>
                <button v-if="withbutton" class="filter-button filter-button--selected" style="margin-top: 20px;" @click="(e) => goToBulletin(e)">
                    {{$t('com.file.bulletin-item.show-bulletin-archive')}}
                </button>
            </section>
        </section>
    </section>
</template>

<script charset="utf-8">
import BulletinService from "@/services/bulletin.service";
export default {
    name: "BulletinItem",
    props: {
        data: Object,
        backgroundcolor: {
            type: String,
            default: "#f4f6fa"
        },
        withbutton: {
            type: Boolean,
            default: false
        },
        withTeaser: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        async goToNews(item){
            try {
                this.$store.commit("showLoader");
                let response = await BulletinService.updateClickStats(item.id);
                if (response.status !== 200) {
                    throw await Promise.reject(response)
                }

                window.open(item.link, "_blank");

            } catch (e) {
                if (e.response.status == 404) {
                    this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'bulletin' } });
                }
                else if (e.response.status == 401) {
                    this.$router.push({ name: 'Login' })
                }
            }
            finally {
                this.$store.commit("hideLoader");
            }
        },
        goToBulletin(e) {
            e.preventDefault();
            this.$router.push({ name: "BulletinPanel" });
        }
    }
};
</script>

<style lang="scss" scoped>


    .bulettin-data {
        margin: 0px 16px;
        padding: 28px 0px;
        border: 0px;
        border-radius: 0px;
        border-bottom: 1px solid #dce4ee;
        display: flex;
        align-items: center;

        &__thumbnail {
            width: 119px;
            margin-right: 24px;
        }

        &__title {
            font-weight: 600;
            font-size: 16px;
            line-height: 132%;
            color: #00082c;
        }

        &__wrapper {
            display: flex;
            align-items: center;
            margin-top: 10px;
        }

        &__date {
            font-weight: 500;
            font-size: 12px;
            line-height: 145%;
            color: #666b80;
            margin-left: 8px;
        }

        &__bulletin-teaser {
            font-size: 12px;
            margin-top: 8px;
            text-align: justify;
        }
    }

    .filter-button {
        margin-right: 8px;
        background: #f4f6fa;
        border-radius: 4px;
        border: 0px;
        padding: 7px 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 132%;
        color: #333956;
        cursor: pointer;

        &--selected {
            color: #ad0313;
            background: #fdf3f4;
        }
    }

</style>
